import React from 'react';
import { useProductosLineas } from './ProductosLineasContext';
import LineaAccordion from '../../components/LineaAccordion';
import '../../styles/capacidades.css';

// Panel producto → líneas: seleccionado un producto (tabla izquierda), muestra las
// líneas en acordeón. Cada línea tiene un toggle para habilitarla/inhabilitarla para
// ese producto; al desplegarla aparecen sus celdas (con la capacidad de línea del back).
export default function ProductosPorLinea() {
    const {
        canEdit,
        isProdSelected,
        areas,
        selectedArea,
        lines,
        enabledLines,
        lineData,
        togglingLine,
        selectArea,
        toggleLinea,
        toggleExpand,
        setCeldaField,
        guardarCapCelda,
        resetCapCelda,
        crearCapacidadLinea,
    } = useProductosLineas();

    const plantaNombre = process.env.REACT_APP_PLANT_NAME || 'Planta';

    const handleAreaChange = (e) => {
        const area = areas.find((a) => String(a.area1) === String(e.target.value)) || null;
        selectArea(area);
    };

    const habilitadas = lines.filter((l) => enabledLines.includes(l.id)).length;

    return (
        <div className="prod-elig-panel">
            <div className="productos-card">
                <div className="cap-filtros">
                    <div className="cap-filtro">
                        <span className="cap-filtro-label">Planta</span>
                        <div className="cap-filtro-planta">{plantaNombre}</div>
                    </div>
                    <div className="cap-filtro">
                        <span className="cap-filtro-label">Área</span>
                        <select
                            className="cap-filtro-selectbox"
                            value={selectedArea?.area1 ?? ''}
                            onChange={handleAreaChange}
                        >
                            {areas.map((area) => (
                                <option key={area.area1} value={area.area1}>{area.nombre}</option>
                            ))}
                        </select>
                    </div>
                    <div className="cap-filtros-meta">
                        {!isProdSelected && (
                            <span>{habilitadas} de {lines.length} líneas habilitadas</span>
                        )}
                        {!canEdit && <span className="cap-filtros-readonly">Solo lectura · Consulta</span>}
                    </div>
                </div>

                {isProdSelected ? (
                    <div className="productos-empty">
                        Selecciona un producto para gestionar sus líneas y capacidades
                    </div>
                ) : lines.length === 0 ? (
                    <div className="productos-empty">No hay líneas para el área seleccionada</div>
                ) : (
                    <div className="cap-acordeon">
                        {lines.map((line) => {
                            const ld = lineData[line.id] || {};
                            const on = enabledLines.includes(line.id);
                            return (
                                <LineaAccordion
                                    key={line.id}
                                    linea={line}
                                    capLinea={ld.capLinea}
                                    lineaSaving={ld.lineaSaving}
                                    lineaEditable={false}
                                    celdasCap={ld.celdas || []}
                                    loading={ld.loading}
                                    expanded={!!ld.expanded}
                                    canEdit={canEdit && on}
                                    toggle={{
                                        on,
                                        disabled: !canEdit || togglingLine === line.id,
                                        onToggle: () => toggleLinea(line.id, !on),
                                    }}
                                    onToggle={() => toggleExpand(line.id)}
                                    onCrearCapacidad={() => crearCapacidadLinea(line.id)}
                                    onChangeCeldaField={(celdaId, key, val) => setCeldaField(line.id, celdaId, key, val)}
                                    onGuardarCelda={(celdaId) => guardarCapCelda(line.id, celdaId)}
                                    onResetCelda={(celdaId) => resetCapCelda(line.id, celdaId)}
                                />
                            );
                        })}
                    </div>
                )}
            </div>
        </div>
    );
}
